import slice from './environment.slice';
export default slice.reducer;
